/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DirtyType } from '@gh/common-shared-data';
import { arrayOf, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';
import { CSMasterListItemStatus } from '../cs-master/models/cs-master.model';
import { SpecTemplateStatus } from '../job-spec-templates/job-spec-template.dto';
import {
  PbCalculatedCcDto,
  PbCcElementDto,
  PbCcStructureSaveDto,
  PbCostCenterSaveDto,
  PbDetailsDto,
  PbDetailsSaveDto,
  PbDetailsSaveResponseDto,
  PbGetCostCenterRequestDto,
  PbHousePlanCalculateResponseDto,
  PbHousePlanDto,
  PbHousePlanSaveDto,
  PbHousePlansRequestDto,
  PbLinkCcElementSaveDto,
  PbLinkCsmDto,
  PbLinkCsmGetResponseDto,
  PbLinkJstDto,
  PbLinkJstGetResponseDto,
  PriceBookFilterDto,
  PriceBookListItemDto,
  PriceBookUsage, PriceBookUsageWithWeb,
} from './price-book.dto';

export const PriceBookListItemMapper = entity<PriceBookListItemDto>({
  usage: enumeration(PriceBookUsageWithWeb),
  repriceDate: date(DateFormat.Date),
  withdrawalDate: date(DateFormat.Date),
  releaseDate: date(DateFormat.Date),
});

export const PbDetailsMapper = entity<PbDetailsDto>({
  usage: enumeration(PriceBookUsage),
  releaseDate: date(DateFormat.Date),
  repriceDate: date(DateFormat.Date),
  withdrawalDate: date(DateFormat.Date),
});

export const PbHousePlanMapper = entity<PbHousePlanDto>({
  dirtyType: enumeration(DirtyType),
});
export const PbHousePlanSaveMapper = entity<PbHousePlanSaveDto>({
  createdDate: date(DateFormat.DateTime),
  dirtyType: enumeration(DirtyType),
});
export const PbHousePlanCalculateResponseMapper = entity<PbHousePlanCalculateResponseDto>();
export const PbDetailsSaveMapper = entity<PbDetailsSaveDto>({
  usage: enumeration(PriceBookUsage),
  releaseDate: date(DateFormat.Date),
  repriceDate: date(DateFormat.Date),
  withdrawalDate: date(DateFormat.Date),
  costCenters: arrayOf(subentity<PbCostCenterSaveDto>({
    dirtyType: enumeration(DirtyType),
  })),
  housePlans: arrayOf(PbHousePlanSaveMapper),
  items: arrayOf(subentity<PbCcStructureSaveDto>({
    dirtyType: enumeration(DirtyType),
  })),
});
export const PbDetailsSaveResponseMapper = entity<PbDetailsSaveResponseDto>({
  housePlans: arrayOf(PbHousePlanMapper),
  items: arrayOf(subentity<PbCcElementDto>({
    dirtyType: enumeration(DirtyType),
  })),
});
export const PbHousePlansRequestMapper = entity<PbHousePlansRequestDto>({
  housePlans: arrayOf(PbHousePlanSaveMapper),
});

export const PbCcStructureMapper = entity<PbCcElementDto>({
  dirtyType: enumeration(DirtyType),
});

export const PbCalculatedCcMapper = entity<PbCalculatedCcDto>({});

export const PbGetCostCenterRequestMapper = entity<PbGetCostCenterRequestDto>({
  items: arrayOf(PbCcStructureMapper),
});

export const PriceBookFilterMapper = entity<PriceBookFilterDto>({
  usage: arrayOf(enumeration(PriceBookUsage)),
});

export const PbLinkJstResponseMapper = entity<PbLinkJstGetResponseDto>({
  specTemplates: arrayOf(subentity<PbLinkJstDto>({
    status: enumeration(SpecTemplateStatus),
  })),
});

export const PbLinkSaveRequestMapper = arrayOf(entity<PbLinkCcElementSaveDto>({}));

export const PbLinkCsmResponseMapper = entity<PbLinkCsmGetResponseDto>({
  colorSelections: arrayOf(subentity<PbLinkCsmDto>({
    status: enumeration(CSMasterListItemStatus),
  })),
});
